<template>
    <div>
      <h1>Petty Cash Basic Services</h1>
      <p>Manage basic petty cash services from here.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PettycashBasicServices',
  };
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>